export const BASE_PATH = "/";
export const NOT_FOUND_PATH = "not-found";
export const SIGN_IN_PATH = "signin";
export const QUOTES_PATH = "quotes";
